<template>
  <van-popup
    :value="show"
    duration="0.1"
    get-container="#app"
    round
    position="bottom"
    :style="{ height: '' }"
    :close-on-click-overlay="false"
    :safe-area-inset-bottom="false"
    class="canEatPopup"
  >
    <!-- 关闭问答按钮 -->
    <div class="clone" @click="closePopup">
      <img src="../../assets/images/home/clone.png" alt="" />
    </div>

    <div class="popup-title">
      <!-- 对比回答(answerObj.answer)和接口返回的答案(getAnswer) -->
      <img
        :src="
          showAnswer()
            ? require('../../assets/images/home/true.png')
            : require('../../assets/images/home/false.png')
        "
        alt=""
      />
      <!-- 对比回答(answerObj.answer)和接口返回的答案(preganecy)
      getAnswer()       answerObj.answer == 0
      !getAnswer()       answerObj.answer == 3
      -->
      {{
        showAnswer()
          ? "星妈您太棒了，回答正确！"
          : "答错了好遗憾，继续加油哦！"
      }}
    </div>
    <!-- 投票结果 -->
    <div class="voting-Results">
      <div class="isTrueProgress">
        <div v-if="show" class="momProgress">
          <div class="progress">
            <div
              class="progress-can"
              :style="{ width: answerObj.allNum }"
            ></div>
          </div>
        </div>
        <div class="momSelect">
          <span>不能吃 : {{ answerObj.foodFalseNum || 0 }}人</span>
          <span>{{ answerObj.foodTrueNum || 0 }}人 : 能吃 </span>
        </div>
      </div>
    </div>
    <!-- 问题 -->
    <div class="question-bg">
      <div class="question-box">
        <div class="problem-title">
          <span class="bg"
            >{{ answerObj.problem }}能吃{{ answerObj.name || "盐" }}吗?</span>
          <div class="answer">答案：{{ getAnswer() ? "能吃" : "不能吃" }}</div>
        </div>
        <div class="problem-content">
          <img
            src="../../assets/images/home/analysis.png"
            class="analysis"
            alt=""
          />
          <div class="article">
            {{
              answerObj.preganecyExplain ||
              answerObj.pregnancyExplain ||
              answerObj.confinementExplain ||
              answerObj.lactationExplain ||
              answerObj.infantExplain
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- 渐变效果 -->
    <div class="gradual-Change-bg">
      <!-- 更多育儿知识 -->
      <div class="more" @click="canEatList">
        更多饮食禁忌 <img src="../../assets/images/home/more.png" alt="" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import { BuiedPointClick_Fn } from "../../assets/js/BuriedPointEvent";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true, // 窗口开关设置必传
    },
    answerObj: {
      type: Object,
      default: () => ({
        foodFalseNum: 0, // 回答不能吃的默认人数
        foodTrueNum: 0, // 回答能吃的默认人数
      }),
    },

  },
  data() {
    return {};
  },
  methods: {
    // 关闭能不能吃互动弹窗
    closePopup() {
      this.$emit("closePopup");
    },
    //去往能不能吃列表页  更多
    canEatList() {
      this.$router.push("/canEatList");
      // 埋点
      BuiedPointClick_Fn("xmhh5_home_zswdmore_click");
    },
    // 答案判断
    getAnswer() {
      // console.log(this.answerObj.pregnancy,'this.answerObj.pregnancy');
      if (this.getProblem("备孕")) {
        return this.answerObj.preganecy == 0;
      }
      if (this.getProblem("孕期")) {
        return this.answerObj.pregnancy == 0;
      }
      if (this.getProblem("月子期")) {
        return this.answerObj.confinement == 0;
      }
      if (this.getProblem("哺乳期")) {
        return this.answerObj.lactation == 0;
      }
      if (this.getProblem("宝宝")) {
        return this.answerObj.infant == 0;
      }
    }, // 判断问题
    getProblem(e) {
      //判断是不是undefined
      if(!this.answerObj.problem) return false
      return this.answerObj.problem.includes(e);
    },
    //判断是否回答正确
    showAnswer() {
      // console.log(this.answerObj.answer,this.getAnswer(),'this.answerObj.answer');
      //能吃
      if(this.answerObj.answer == 0) {
        return this.getAnswer() ? true : false
      }
      // 不能吃
      if(this.answerObj.answer == 3) {
        return !this.getAnswer() ? true : false
      }
    },
  },
  watch: {
    //监听弹窗内容
    answerObj: {
      deep: true,
      handler(newVal) {
        console.log(newVal, "newVal", this.answerObj);
      },
    },
  },
  computed: {
    // 计算投票的百分比
    percentage() {
      const all = this.answerObj.foodTrueNum + this.answerObj.foodFalseNum;
      // console.log(this.answerObj,all)
      if (!all) {
        // 防止出错 判断回答人数全为0 时
        return "0%";
      }
      return (this.answerObj.foodFalseNum / all) * 100 + "%";
    },
  },
};
</script>
<style lang="less" scoped>
.canEatPopup {
  width: 375px;
  background: linear-gradient(180deg, #f6e1f3 0%, #ffffff 100%);
  .clone {
    position: absolute;
    right: 8px;
    top: 4px;
    img {
      width: 32px;
      height: 32px;
    }
  }
  .popup-title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #f571bc;
    margin: 17px 0px 15px 16px;
    display: flex;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
      display: inline;
      margin-right: 10px;
      // margin-top: -1px;
    }
  }
  .voting-Results {
    padding: 0 0px 4px 18px;
    .momProgress {
      margin-bottom: 5px;
      .progress {
        width: 345px;
        height: 4px;
        background: #f470be;
        border-radius: 3px;
        margin-top: 1px;
        overflow: hidden;
        .progress-can {
          // width: 108px;
          height: 4px;
          background: #7762ff;
        }
      }
    }
    .momSelect {
      display: flex;
      justify-content: space-between;
      // margin-top: 1px;
      span {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        padding-right:11px;
      }
    }
  }
  .question-bg {
    width: 359px;
    height: 322px;
    background: #fff;
    border-radius: 15px 15px 0px 0px;
    margin: 13px auto 0px;
    .question-box {
      padding: 0 16px;
      .problem-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3d3d3d;
        // line-height: 23px;
        padding-top: 20px;
        .bg {
          background: rgba(244, 112, 190, 0.1) no-repeat 0 32px;
        }
        .answer {
          // width: 80px;
          height: 23px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #3d3d3d;
          padding-top: 5px;
        }
      }
    }
    .problem-content {
      margin-top: 24px;
      img {
        margin-top: 2px;
        width: 32px;
        height: 17px;
        float: left;
      }
      .article {
        height: 42px;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
        text-indent: 0.5em;
      }
    }
  }
  .gradual-Change-bg {
    padding:34px 0;
    width: 359px;
    margin: 0 auto;
    background: #ffffff;
    // opacity: 0.9;
    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f470be;
      text-align: center;

      img {
        width: 16px;
        height: 16px;
        margin-left: 6px;
        // vertical-align: middle;
      }
    }
  }
}
</style>